<script setup>
import { useGlobalStore } from '@stores/global'
import { ref } from 'vue'

import Button from '@components/global/button.vue'

const global = useGlobalStore()
</script>
<template>
	<div class="bg-bgSecondary">
		<section class="container flex flex-col items-center gap-10 text-center">
			<div class="flex max-w-[650px] flex-col items-center gap-4">
				<h4 class="font-regular">The Garden Keepers</h4>
				<p class="text">Every great garden needs a little tending, and our team is here to keep things thriving. From cultivating ideas to growing the community, we make sure Garden Mother stays fresh, fun, and always in full bloom.</p>
			</div>
			<div class="flex flex-wrap justify-center gap-6">
				<div v-for="teamMember of global.team" class="flex flex-col text-start">
					<div class="rounded-lg bg-border p-16">
						<img :src="teamMember.image" alt="" class="aspect-square w-36 rounded-full object-cover mix-blend-luminosity" />
					</div>
					<span class="mt-4 font-light text-xs uppercase tracking-[2.4px] text-primaryLight">{{ teamMember.role }}</span>
					<span class="mt-1">{{ teamMember.name }}</span>
				</div>
			</div>
		</section>
	</div>
</template>
